import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import _ from 'lodash';

import { Button } from 'react-bootstrap';

import Assignee from './Assignee';
import Tags from './Tags';

class FindingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.updateAssignedUsers = this.updateAssignedUsers.bind(this);
  }

  updateAssignedUsers(newAssignee = [], role) {
    const { update, finding } = this.props;
    const newEvent = {
      ...finding,
    };
    let assignee = _.filter(newEvent.assignee, a => a.role !== role);
    assignee = assignee.concat(newAssignee);
    update({
      ...finding,
      assignee,
    });
  }

  render() {
    const {
      finding = {},
      assignableUsers = [],
    } = this.props;
    return (
      <div className='detail'>
        <div className='title'>{finding.name}</div>
        <span style={{ width: '50%', display: 'inline-block' }}>
          <p>{finding.id}</p>
        </span>
        <span style={{ width: '50%', display: 'inline-block', textAlign: 'right' }}>
          <p>{moment(finding.created).format('M/D/YYYY h:mm:ss A')}</p>
        </span>
        <div className='section'>
          <h5>Analysts Assigned To:</h5>
          <Assignee
            assignee={_.filter(finding.assignee, a => a.role === 'analyst')}
            assignableUsers={_.filter(assignableUsers, a => a.role === 'analyst')}
            update={_.partial(this.updateAssignedUsers, _, 'analyst')}
          />
        </div>
        <div className='section'>
          <h5>Responders Assigned To:</h5>
          <Assignee
            assignee={_.filter(finding.assignee, a => a.role === 'responder')}
            assignableUsers={_.filter(assignableUsers, a => a.role === 'responder')}
            update={_.partial(this.updateAssignedUsers, _, 'responder')}
          />
        </div>
        <div className='section'>
          <h5>Analyst Summary:</h5>
          <p>
            Lorem ipsum dolar sit amit furtado unit sequitar. Lorem ipsum dolar sit amit
            furtado unit. Lorem ipsum dolar sit amit furtado unit sequitar. Lorem ipsum
            dolar sit amit furtado unit. Lorem ipsum dolar sit amit furtado unit sequitar.
          </p>
        </div>
        <div className='section'>
          <h5>Threat Summary:</h5>
          <p>
            Lorem ipsum dolar sit amit furtado unit sequitar. Lorem ipsum dolar sit amit
            furtado unit. Lorem ipsum dolar sit amit furtado unit sequitar. Lorem ipsum
            dolar sit amit furtado unit. Lorem ipsum dolar sit amit furtado unit sequitar.
          </p>
        </div>
        <div className='section'>
          <h5>Tags:</h5>
          <Tags finding={finding} tags={finding.tags} />
        </div>
        <div className='section'>
          <h5>Related Threats:</h5>
        </div>
        <div className='section'>
          <h5>Originating Suspect:</h5>
        </div>
        <div className='section'>
          <h5>Originating Criteria:</h5>
        </div>
        <div className='section'>
          <h5>Source Events:</h5>
        </div>
        <div className='section'>
          <h5>Sources:</h5>
        </div>
        <div className='footer-gradient' />
        <div className='actions'>
          <span>
            <Button bsStyle='danger'>
              Revert
            </Button>
          </span>
          <span>
            <Button bsStyle='primary'>
              Save Changes
            </Button>
          </span>
        </div>
      </div>
    );
  }
}

FindingDetail.propTypes = {
  finding: PropTypes.shape({}),
  assignableUsers: PropTypes.instanceOf(Array),
  update: PropTypes.func.isRequired,
};

FindingDetail.defaultProps = {
  finding: {},
  assignableUsers: [],
};

export default FindingDetail;



// WEBPACK FOOTER //
// ./src/views/Components/FindingDetail.js